import { render, staticRenderFns } from "./SVGBase.vue?vue&type=template&id=609a4449&"
import script from "./SVGBase.vue?vue&type=script&lang=js&"
export * from "./SVGBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports